import styled from 'styled-components'
import Colors from '../../constants/colors'
import { BlogThreshold as Threshold } from '../../constants/theme'

export const Container = styled.div`
  margin-bottom: 40px;
  line-height: 1.5;

  h2 {
    margin: 16px 0;
    text-transform: uppercase;
  }
  
  h3 {
    margin: 16px 0;
    font-family: StolzlRegular, sans-serif;
    font-size: 16px;
    line-height: normal;
    letter-spacing: normal;
    text-transform: uppercase;
  }

  p {
    margin: 30px 0;
    letter-spacing: 2px;
    line-height: 1.88;
    text-align: left;
    color: #080707;
  }
  
  ul, ol {
    padding-left: 18px;
    margin: 15px 0;
  }
  
  ol {
    padding-left: 25px;
  }
  
  li {
    margin: 15px 0;
  }
  
  img {
    border-radius: 10px;
    max-width: 100%;
    height: auto;
  }
  
  blockquote {
    margin: 25px 0;
    padding: 32px 0 26px;
    border: solid ${Colors.primary};
    border-width: 2px 0;
    font-family: StolzlMedium, sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    text-transform: uppercase;
    color: #000000;
    
    > div {
      //display: flex;
      position: relative;
      margin-top: 14px;
      padding-left: 47px;
      
      ::before {
        flex: none;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        content: '';
        width: 35px;
        height: 35px;
        padding-right: 12px;
        background: url('/static/images/quote.svg');
        background-size: contain;
        background-repeat: no-repeat;
      }
      
      div {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 1.57;
        letter-spacing: normal;
        text-transform: none;
        color: #000;
      }
      
      div:first-child {
         font-family: StolzlRegular, sans-serif;
      }  
      
      div:last-child {
        font-family: StolzlLight, sans-serif;
      }
    }
  }
  
  strong {
    font-family: StolzlMedium, sans-serif;
  }
  
  table {
    width: 100% !important;
  }
  
  @media(max-width: ${Threshold.tablet}) {
    p {
      text-align: left;
    }
  }
`
